import createFormSlice from '@/store/reducers/createFormSlice';
import { createSlice } from '@reduxjs/toolkit';
import { simulateSendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '../../api/apiConfig';
import { LoginFormTypes } from '@/store/types/loginFormTypes';

const loginFormData: LoginFormTypes = {
	email: '',
	password: '',
	// Как hidden input remember=1 на blade: чекбокса в UI нет, всегда true.
	remember: true,
};

const formSlice = createFormSlice('loginForm', loginFormData);

const combinedSlice = createSlice({
	name: 'loginForm',
	initialState: formSlice.getInitialState(),
	reducers: {
		...formSlice.caseReducers,
	},
});

export const {
	resetSuccessMessage,
	setError,
} = combinedSlice.actions;

// API ещё не готов — заглушка с полным протоколом slice'а.
// Когда бэкенд сделает эндпоинт: simulateSendForm → sendForm (одно слово),
// контракт — в `src/store/types/loginFormTypes.ts`.
export const sendLogin = (data: LoginFormTypes) => simulateSendForm(combinedSlice, API_ENDPOINTS.login, 'auth.login.success_message')(data);

export default combinedSlice.reducer;
export { combinedSlice as loginFormSlice };
